import { render, staticRenderFns } from "./novel_list.vue?vue&type=template&id=328c73ba&scoped=true&"
import script from "./novel_list.vue?vue&type=script&lang=js&"
export * from "./novel_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c73ba",
  null
  
)

export default component.exports